import React from "react";
import EditPersonaGroup from "./edit";
import { Action, View, Delete } from "../../../shared";
import { DELETE_PERSONA } from "./query";
import { type Props } from "./types";

const PersonaAction = (props: Props) => {
    const { data } = props;

    const personaAction = [
        {
            id: `viewPersona${data.id}`,
            name: "View Persona",
            content: (
                <View
                    title="View Persona Group"
                    viewData={[
                        { label: "Persona Name", key: "personaName" },
                        { label: "Application Name", key: "appName" },
                        { label: "Country", key: "country" },
                        { label: "Created At", key: "createdAt" },
                        { label: "Email", key: "email" },
                    ]}
                    data={data}
                />
            ),
        },
        {
            id: `editPersona${data.id}`,
            name: "Edit Persona",
            content: <EditPersonaGroup {...props} title="Edit Persona" personaGroup={data} />,
        },
        {
            id: `deletePersona${data.id}`,
            name: "Delete Persona",
            content: <Delete title="Persona" id={data.id.toString()} query={DELETE_PERSONA} />,
        },
    ];

    return <Action {...props} actionTabItems={personaAction} />;
};

export default PersonaAction;
